import {baseApi} from './baseApi';

export const injectedUtilisationApi = baseApi.injectEndpoints({
    addTagTypes: ['Utilisation'],
    endpoints: (builder) => ({
        getUtilisationOverview: builder.query({
            query: (args) => {
                const {projectId, mapping} = args;

                let url = `getUtilisationOverview?project_id=${projectId}`;

                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['Utilisation']
        }),
        getUtilisationTranslate: builder.query({
            query: (args) => {
                const {projectId} = args;

                let url = `getUtilisationTranslate?project_id=${projectId}`;

                return {url: url};
            },
            providesTags: ['Utilisation']
        }),
        setUtilisationTranslate: builder.mutation({
            query: (body) => ({
                url: 'setUtilisationTranslate',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Utilisation']
        }),
        createUtilisation: builder.mutation({
            query: (body) => ({
                url: 'createUtilisation',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Utilisation']
        }),
        updateUtilisation: builder.mutation({
            query: (body) => ({
                url: 'updateUtilisation',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Utilisation']
        }),
        deleteUtilisation: builder.mutation({
            query: (body) => ({
                url: 'deleteUtilisation',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Utilisation']
        }),
        refetchErroredQueries: builder.mutation({
            queryFn: () => ({data: null}),
            invalidatesTags: ['UNKNOWN_ERROR'],
        }),
        getUtilisationTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getUtilisationTypes'};
            },
            providesTags: ['Utilisation']
        }),
    }),
});

export const {
    useGetUtilisationOverviewQuery,
    useGetUtilisationTranslateQuery,
    useSetUtilisationTranslateMutation,
    useCreateUtilisationMutation,
    useUpdateUtilisationMutation,
    useGetUtilisationTypesQuery,
} = injectedUtilisationApi;
